import axios from "axios";
import { userStore } from "@/stores/modules/user";
import type {
  AxiosInstance,
  CreateAxiosDefaults,
  InternalAxiosRequestConfig,
  AxiosError,
} from "axios";

const baseUrl = process.env.NODE_ENV == "development" ? "/api" : "/api";

interface axiosConfig {
  loading?: boolean;
  authorization?: boolean;
}
const defaultConfig: axiosConfig = {
  loading: true,
  authorization: true,
};

interface customRequestConfig extends InternalAxiosRequestConfig {
  customsOptions?: axiosConfig;
}

const requestInterceptors = (config: customRequestConfig) => {
  const { customsOptions } = config;
  const userState = userStore();
  if (customsOptions?.authorization) {
    config.headers.token = userState.getToken;
  }
  config.headers.tenant_id = userState.userInfo.tenantId;
  return config;
};

class Request {
  instance: AxiosInstance;
  constructor(config?: CreateAxiosDefaults) {
    this.instance = axios.create(config);
    this.instance.interceptors.request.use(requestInterceptors);
    this.instance.interceptors.response.use((rep) => {
      const { data } = rep;
      if (
        data.status == 200 ||
        data.msg === "success" ||
        data.msg === null ||
        data.code == 0 ||
        data.code == 200 ||
        data.code == 500
      ) {
        return Promise.resolve(data);
      } else {
        return Promise.reject(data);
      }
    });
  }
  request<T = any>(
    method = "GET",
    url: string,
    data?: any,
    config: axiosConfig = { loading: false, authorization: true }
  ): Promise<T> {
    const options = Object.assign(defaultConfig, config);
    return new Promise((resolve, reject) => {
      this.instance({ method, url, ...data, customsOptions: options })
        .then((res) => {
          resolve(res as unknown as Promise<T>);
        })
        .catch((e: Error | AxiosError) => {
          reject(e);
        })
        .finally(() => {
          if (options.loading) {
          }
        });
    });
  }
  get<T = any>(url: string, data?: any, config?: axiosConfig): Promise<T> {
    return this.request("GET", url, { params: data }, config);
  }
  post<T = any>(url: string, data?: any, config?: axiosConfig): Promise<T> {
    return this.request("POST", url, { data }, config);
  }
}

const request = new Request({
  timeout: 30000,
  baseURL: baseUrl,
});

export default request;
